import './components'
import './directives'
import './validation'
import './resource'

import VueI18n from 'vue-i18n'

Vue.use(VueI18n)
// import {i18n} from './plugins/i18n'



const messages = { current: window.django.catalog || {} }

Vue.prototype._ = function () {
  return this.$t.apply(this, arguments)
}

export const i18n = new VueI18n({
  locale: 'current',
  messages,
  silentTranslationWarn: true
})


window.app = new Vue({
  el: '#app',
  i18n,
})



// WEBPACK FOOTER //
// ./src/js/main.js